// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"savedListsEmptyState__gradient-bg5__xQ1JC","panel":"savedListsEmptyState__panel__eLcWC","preview":"savedListsEmptyState__preview__PvdWQ"};